<template>
  <div>
    <div class="bg-section">
      <v-col
        lg="4"
        md="5"
        sm="8"
      >
        <v-card
          class="elevation-10 outter-section"
          color="#FFFFFF"
        >
          <v-card-title>
            <h3>Log In</h3>
          </v-card-title>
          <v-card-text>
            <br>
            <br>
            <p class="welcome-style">
              Welcome Back
              <span class="number-style">{{ phoneNumber }}</span>
            </p>
            <br>
            <p class="subheader-style">
              Please enter your passcode to login.
            </p>
            <br>
            <v-form
              ref="form"
              v-model="valid"
            >
              <div class="otp-style-device">
                <v-otp-input
                  v-model="passcode"
                  type="password"
                  :rules="[(v) => !!v || 'This field is required']"
                  length="4"
                  inputmode="numeric"
                  light
                  filled
                  color="#37474F"
                />
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="pr-5 pb-5">
            <v-spacer />
            <v-btn
              elevation="0"
              class="cancel-style"
              @click="backPage()"
            >
              Back
            </v-btn>
            <v-btn
              elevation="0"
              class="next-style"
              @click="workerLogin()"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
export default {
  name: 'AppUserLoginPage',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      passcode: null,
      loading: false,
      phoneNumber: null,
      appUserId: null,
      valid: false,
    };
  },
  computed: {
    appUserCheckInRecord () {
      return this.$store.getters['devices/getActiveCheckInDetails'];
    },
    checkAppUserCheckInRecord () {
      if (Object.keys(this.appUserCheckInRecord).length !== 0) {
        return true;
      }
      return false;
    },
    getCheckInType () {
      return this.$store.getters['devices/getCheckInType'];
    },
    deviceData () {
      return this.$store.getters.getDeviceData;
    },
  },
  async mounted () {
    this.loading = true;
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    loadOnMount () {
      if (!this.$route.params.phone_number) {
        this.loading = true;
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
        this.loading = false;
      } else {
        this.phoneNumber = this.$route.params.phone_number;
        this.appUserId = this.$route.params.app_user_id;
      }
    },
    async workerLogin () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      try {
        await this.$store.dispatch('loginKioskUser', {
          loginDetails: {
            phone_number: this.phoneNumber,
            password: this.passcode,
          },
        });
        localStorage.removeItem('timerTime');
        this.getCheckInRecords();
      } catch (error) {
        this.$store.dispatch('alert/onAlert', {
          message: error.response.data.message,
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getCheckInRecords () {
      await this.$store.dispatch('devices/fetchUsersCurrentCheckInDetails')
        .then(response => {
          this.loading = true;
          if (Object.keys(this.appUserCheckInRecord).length !== 0) {
            const checkInTime = +new Date(this.appUserCheckInRecord.checkin_time);
            localStorage.setItem('checkInTime', checkInTime);
            this.loading = false;
          } else {
            localStorage.removeItem('checkInTime');
            localStorage.removeItem('checkIn');
            this.showCheckInButton = true;
            this.loading = false;
          }
        }).catch(() => {
          this.loading = false;
        });
      try {
        this.loading = true;
        if ((this.deviceData.organization_id.external_id === this.appUserCheckInRecord.organization_id && (this.appUserCheckInRecord.type === 'worker')) || Object.keys(this.appUserCheckInRecord).length === 0) {
          if (Object.keys(this.appUserCheckInRecord).length !== 0) {
            if (this.getCheckInType === 'checkin') {
              this.$store.dispatch('alert/onAlert', {
                message: 'Please checkout before checkin',
                type: Constants.ALERT_TYPE_ERROR,
              }, { root: true });
              this.$router.push({ name: 'DeviceCheckOutCostShift' });
            } else {
              this.$router.push({ name: 'DeviceCheckOutCostShift' });
            }
          } else {
            if (String(this.getCheckInType) === 'checkout') {
              this.$store.dispatch('alert/onAlert', {
                message: 'Please checkin before checkout',
                type: Constants.ALERT_TYPE_ERROR,
              });
              this.$router.push({ name: 'DeviceSelectProject' });
            } else {
              this.$router.push({ name: 'DeviceSelectProject' });
            }
          }
        } else {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'You are already active in another device.',
            type: Constants.ALERT_TYPE_ERROR,
          });
          await this.$store.dispatch('devices/workerLogout');
          await this.$store.dispatch('kioskUserLogout');
          this.loading = false;
          await this.$router.push({ name: 'DeviceCheckInCheckOut' });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'An error occurred while processing your request.',
          type: Constants.ALERT_TYPE_ERROR,
        });
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }
    },

    backPage () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.v-card__title {
  background: #f8f8f8;
}

.v-card {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.582);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.445);
}

.theme--dark>>>.v-label {
  color: #101010;
}

.next-style,
.cancel-style {
  width: 100px;
  height: 40px !important;
}

.next-style {
  background: #37474f !important;
}

.cancel-style {
  background: #e2e2e2 !important;
  color: #37474f;
}

.outter-section {
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.outter-section:before {
  z-index: -1;
  position: absolute;
  content: "";
  right: -80px;
  top: -100px;
  width: 200px;
  height: 1000px;
  transform: rotate(10deg);
  background: #ececec;
}

.outter-section:after {
  z-index: -1;
  position: absolute;
  content: "";
  right: -100px;
  top: -80px;
  width: 250px;
  height: 1000px;
  transform: rotate(30deg);
  background: #f8f8f8;
}
</style>
